export default "__VITE_ASSET__Ce50Maue__"